import { render } from "./LoadingButton.vue?vue&type=template&id=11edc1b2&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=ts"
export * from "./LoadingButton.vue?vue&type=script&lang=ts"

import "./LoadingButton.vue?vue&type=style&index=0&id=11edc1b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-11edc1b2"

export default script